var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"push"},[_c('v-btn',{on:{"click":_vm.pushMoreData}},[_vm._v("Add Data")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }